<script lang="ts" setup>
import items from './termsandconditions.json';

import ContractTerms from '~/components/common/ContractTerms.vue';

const title = 'Terms & Conditions';

useSeoMeta({
  title
});
</script>

<template>
  <ContractTerms
    :title="title"
    :items="items"
  />
</template>
